
import React, { useContext, useEffect, useRef, useState } from "react";
import Modal from "react-bootstrap/Modal";
import searchicon from "../../assets/images/search_icon copy.svg";
import importicon from "../../assets/images/import.svg";
import exporticon from "../../assets/images/export.svg";
import editicon from "../../assets/images/bx_edit.svg";
import building from "../../assets/images/building.svg";
import popup from "../../assets/images/popup-link-icon.svg";
import righticon from "../../assets/images/right.svg";
import close from "../../assets/images/close.svg";
import Pagination from "../ChatAdmin/Pagination";
import { useLocation, useNavigate } from "react-router-dom";
import { AppContext } from "../../context/AppContext";
import { validEmail } from "../ChatAdmin/commaon";
import { PostCallWithErrorResponse, simpleGetCallWithErrorResponse } from "../../api/ApiServices";
import ApiConfig from "../../api/ApiConfig";
import { ToastMsg } from "../TostMsg";
import Loader from "../Loader";
import NoData from "../../sharedComponent/NoData";
import CommonButton from "../ChatAdmin/button";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown, faChevronUp, faL } from "@fortawesome/free-solid-svg-icons";
import { Accordion } from "react-bootstrap";
import { ClipLoader } from "react-spinners";
function Members(props) {
  const Useridlogin = localStorage.getItem("UserId")

  const { fromDynamic = false,
    keyName,
    handleAddTask,
    setClientStep,
    createId,
    setCreateId,
  } = props

  const { sidebar, userData, permissions, handleSetBack } = useContext(AppContext);
  const [pageSize, setPageSize] = useState(25)
  const [currentPage, setCuurentPage] = useState(1)
  const [totalPage, setTotalPage] = useState(0)
  const [isApiLoad, setIsLoad] = useState(false)
  const [show1, setShow1] = useState(false);
  const [checkStatus, SetCheckStatus] = useState(true)
  const [searchFields, setSearchFields] = useState("")
  const [filterSearchName, setFilterSearchName] = useState([])
  const [clientOptions, setClientOptions] = useState([]);//clent option for select
  const [isActivedata, setIsActivedata] = useState("")


  const navigate = useNavigate()
  const location = useLocation();
  const ClientId = location.state?.Member
    ;
  const clientDetails = {
    Id: 0,
    "FirstName": "",
    "MiddleName": "",
    "LastName": "",
    "Email": "",
    "Phone": "",
    "ClientId": ClientId

  }




  const [cliendDet, setCliientDet] = useState(clientDetails)
  const [clientList, setClientList] = useState([])
  const [memberList, setMemberList] = useState([])

  const [clientQationList, setClientQationList] = useState([])
  const [isLoading, setIsLoading] = useState(false)
  const [isFiiledDetails, setIsFilledDetails] = useState(false)
  const [cliendCreateId, setCliendtCreateId] = useState(0)

  const [validated, setValidated] = useState(false);

  const [show, setShow] = useState(false);
  const [ShowPopop, setShowPopop] = useState(false);
  const clientId = useRef()
  const [expanded, setExpanded] = useState(false);
  const [userid, setuserid] = useState(
    ""
  )

  console.log("client Update Data", cliendDet)

  const toggleExpand = () => setExpanded(!expanded);
  const handleShow = () => {
    // only override clientId for create
    if (cliendDet.Id === 0) {
      setCliientDet((prev) => ({
        ...prev,
        ClientId: ClientId,
      }));
    }
    setShow(true);
  };

  const handleShowList = (id) => {
    setShowPopop(true)
    // getQationList(id)
  };
  const handleCloseList = () => setShowPopop(false);
  const handleClose = () => {
    setValidated(false)
    setCliientDet(clientDetails)
    setIsFilledDetails(false)
    setShow(false)
  }

  const handleShowActive = (item) => {
    clientId.current = item
    setShow1(true)
    if (item.isActive == true) {
      setIsActivedata(false)
    }
    else {
      setIsActivedata(true)
    }
    console.log(item, "item");
    setuserid(item.userId)

  }
  const handleCloses = () => {
    setShow1(false)
  };






  const handleChange = (key, val) => {

    setCliientDet(prev => ({
      ...prev,
      [key]: val
    }))

  }
  // const HandleSelect =(e)=>{
  // }
  //.......Member list Api//.......
  const getMemberList = (page) => {
    if (page > 1) {
      setIsLoading(false)
    } else {
      setIsLoading(true)
    }

    simpleGetCallWithErrorResponse(ApiConfig.GET_MEMBERLIST + `clientId=${ClientId}&active=${checkStatus}`).then((res) => {


      if (res?.json?.success) {

        console.log("Client List Response:", res?.json?.data);

        setTotalPage(res?.json?.pageCount);
        setMemberList(res?.json?.data);

      }


      setIsLoading(false)

    })
    console.log("secondcdtn");
  }







  useEffect(() => {

    getMemberList(currentPage)

  }, [currentPage, pageSize, checkStatus])



  //.....input client list......///
  const getClientList = () => {
    simpleGetCallWithErrorResponse(ApiConfig.GET_CLIENTS).then((res) => {


      if (res?.json?.success) {

        setTotalPage(res?.json?.pageCount)

        setClientList(res?.json?.data)
        setClientOptions(res?.json?.data);

      }

      setIsLoading(false)

    })
  }
  useEffect(() => {

    getClientList(currentPage)

  }, [])



  //.....create Api......//
  const handleCreate = () => {


    let keys = Object.keys(cliendDet)

    let isValid = true


    keys.forEach((key) => {

      if (key == 'MiddleName') return;

      if ((key != "Id" && key != 'UserId' && key != 'emailOtp' && key != 'noOtp') && !cliendDet[key]) {


        isValid = false

        console.log(1, key);
        setValidated(true)

      }

      if (key == 'Email' && !validEmail(cliendDet[key])) {

        isValid = false


        setValidated(true)

      }

      if (key == "Phone" && cliendDet[key].length != 10) {

        isValid = false
        console.log(3);

        setValidated(true)

      }

    })
    console.log("upper", isValid, cliendDet);
    if (isValid) {

      console.log("downn");



      setIsLoad(true)

      let body = {
        "FirstName": cliendDet.FirstName,
        "MiddleName": cliendDet.MiddleName,
        "LastName": cliendDet.LastName,
        "Email": cliendDet.Email,
        "Phone": cliendDet.Phone,
        "ClientId": Number(cliendDet.ClientId)
      }




      // body.UserId = Number(userData.UserId)
      console.log(cliendDet);

      let url = clientId.Id == 0 ? ApiConfig.CREATE_MEMBER : ApiConfig.UPDATE_MEMBER
      console.log(url = cliendDet.Id == 0 ? ApiConfig.CREATE_MEMBER : ApiConfig.UPDATE_MEMBER, "function loading let");

      PostCallWithErrorResponse(url, JSON.stringify(body)).then((res) => {


        if (res?.json?.success) {
          ToastMsg('success', res?.json?.message)
          handleClose();

          if (fromDynamic) {
            setCreateId(res?.json?.data?.id)

            setCliendtCreateId(res?.json?.data?.id)

          } else {
            getMemberList()
          }
          setIsFilledDetails(true)
          setIsLoad(false)

        } else {
          ToastMsg('error', res?.json?.message)

          setIsLoad(false)
        }


      })


    }
    console.log("working");

  }

  //....Active/Deactive....//
  const onActiveSubscription = () => {
    setIsLoad(true);
    const id = clientId.current?.id
    PostCallWithErrorResponse(ApiConfig?.ACTIVEINACTIVE_MEMBER + `userId=${userid}&isActive=${isActivedata}`)
      .then((res) => {
        if (res?.json?.success === true) {
          ToastMsg("success", res?.json?.message);
          setIsLoad(false);
          setShow1(false)
          getMemberList()
        } else {
          ToastMsg("error", res?.json?.message);
        }
        console.log("update Data>>>", res)
        setIsLoad(false)
      })
      .catch((err) => {
        console.log("update Data Error >>>", err)
      })
  }
  console.log(onActiveSubscription, "subscription");


  useEffect(() => {

    const filterData = memberList?.filter((item) => {
      const searchData = searchFields?.toLocaleLowerCase()

      return (
        item?.phone?.toLowerCase().includes(searchData) ||
        item?.firstName?.toLowerCase().includes(searchData) ||
        item?.middleName?.toLowerCase().includes(searchData) ||
        item?.lastName?.toLowerCase().includes(searchData) ||
        item?.email?.toLowerCase().includes(searchData)

      );

    })
    setFilterSearchName(filterData)
  }, [clientList, searchFields, memberList])



  const removeStep = (index, id) => {
    // state?.tasks?.splice(index, 1);


  };

  return (
    <div className={sidebar ? "taskMain " : "cx-active taskMain"} id={fromDynamic ? "" : "cx-main"}>

      <>
        <div className="role-content">
          <div className="sub-header-role userList33">
            <h6 className="mt-2 role-text">
              <span
                className="me-1 bread-cumb-color"
                onClick={() => navigate("/clientlist")}
              >
                Client
              </span>
              <span className="me-1 back-slash"> /</span>
              <span

                onClick={() => navigate("/Members")}
              >
                Members{" "}
              </span>
            </h6>
            {/* <h6 className="mt-2 role-text">Member </h6> */}
            <div>

              {
                permissions && permissions['Create Client Members'] &&

                <button
                  className="create-btn-sub-header"
                  style={{ marginRight: "0" }}
                  onClick={handleShow}
                >
                  Add Members
                </button>
              }
            </div>
          </div>
          <div className="d-flex justify-content-between role-searchbar-and-btns resposiveheadder">
            <div className="role-table-header reponsivesrc">
              <div className="search-input-wrapper">
                <input type="text"
                  placeholder="Search"
                  onChange={(e) => setSearchFields(e.target.value)}
                />
                <img src={searchicon} alt="" />
              </div>
              <div className="entries-wrapper">
                <p>Entries per page</p>
                <select
                  class="form-select select-drop-icon remove-border"
                  aria-label="Default select example"
                  value={pageSize}
                  onChange={(e) => setPageSize(e.target.value)}
                >

                  <option value="25" selected>25</option>
                  <option value="50">50</option>
                  <option value="75">75</option>
                  <option >100</option>
                </select>
              </div>
              {
                permissions && permissions['Active / Deactive Client Members'] &&

                <div className="entries-wrapper">
                  <p>Select Status</p>
                  <select
                    class="form-select select-drop-icon remove-border"
                    aria-label="Default select example"
                    value={checkStatus}
                    onChange={(e) => {
                      SetCheckStatus(e.target.value);
                      setCuurentPage(1)

                    }}
                  >
                    <option value={""} selected>Select</option>
                    <option value={true} >Active</option>
                    <option value={false}>De-Active</option>
                  </select>
                </div>
              }
            </div>
            {
              permissions && permissions['Export Client Members'] &&
              <div className="role-btns-wrapper">

                {/* <button>
                      <img src={importicon} alt="" />
                    </button> */}
                <button className="lastchalidbtn">
                  {" "}
                  <img src={exporticon} alt="" />
                </button>
              </div>
            }
          </div>

          <div className="table-wrapper-main mb-4">
            <table>
              <tr className="firstTabelRow">
                <th>Sr. no</th>

                <th>First Name</th>
                <th>Middle Name</th>
                <th>Last Name</th>
                <th>Phone</th>
                <th>Email</th>
                <th>Status</th>
                {
                  permissions && permissions['Edit Client Members'] &&

                  <th className="mx-3">Action</th>
                }
              </tr>
              {isLoading ? (
                <tr>
                  <td colSpan="9" className="text-center">
                    <Loader />
                  </td>
                </tr>
              ) : memberList?.length === 0 ? (
                <tr>
                  <td colSpan="9" className="text-center">
                    <NoData />
                  </td>
                </tr>
              ) : (
                filterSearchName?.map((client, index) => (
                  // memberList.map((client, index) => (
                  <tr className="table-row-custom" key={client.userId}>
                    <td>{index + 1}</td>

                    <td>{client.firstName}</td>
                    <td>{client.middleName}</td>
                    <td>{client.lastName}</td>
                    <td>{client.phone}</td>
                    <td>{client.email}</td>

                    <td

                      onClick={() => {
                        permissions && permissions['Access to Active/De-Active Client'] && handleShowActive(client)
                      }}
                    >
                      <span
                        style={{ color: client?.isActive ? 'green' : 'red' }}>
                        {client.isActive ? 'Active' : 'De-Active'}
                      </span>
                    </td>
                    {
                      permissions && permissions['Edit Client Members'] &&
                      <td>

                        <img
                          src={editicon}
                          alt=""
                          className="mx-3"
                          onClick={() => {
                            setCliientDet({
                              Id: 1,


                              "ClientId": client.clientId,
                              "FirstName": client.firstName,
                              "MiddleName": client.middleName,
                              "LastName": client.lastName,
                              "Email": client.email,
                              "Phone": client.phone,

                            })
                            handleShow()
                          }}
                        />



                      </td>
                    }
                  </tr>
                ))
              )}
            </table>
          </div>

          {/* <<<<<<...................modal create starts here..........................>>>> */}
          <Modal
            aria-labelledby="contained-modal-title-vcenter"
            centered
            show={show}
            className="modal-xl"
          >
            <Modal.Header>
              <Modal.Title>
                <label htmlFor="" className="create-role-text">
                  {cliendDet?.Id === 0 ? 'Add' : 'Update'} Member
                </label>
              </Modal.Title>
              <img src={close} alt="" onClick={handleClose} />
            </Modal.Header>
            <div className="hr-line-modal">
              <hr style={{ margin: "0" }} />
            </div>
            <Modal.Body>
              <div className="row">
                {/* <div className="col-lg-3 mt-4">
                      <label htmlFor="" className="text-grey">
                        Title
                      </label>
                      <select
  className="form-select tasKCategory1 select-drop-icon"
  aria-label="Select Client"
  value={cliendDet.ClientId}
  onChange={(e) => {
    handleChange("ClientId", e.target.value);
  }}
>
  <option value="">Select Client</option>
  {clientOptions.map((client) => (
    <option key={client.id} value={client.id}>
      {client.firstName}
    </option>
  ))}
</select>
<p className="text-danger">
  {validated && !cliendDet?.ClientId && "Please Select Client"}
</p>
            
                    </div> */}
                <div className="col-lg-3 mt-4">
                  <label htmlFor="" className="text-grey">
                    First Name
                  </label>
                  <input type="text" className="form-control tasKCategory1"
                    value={cliendDet.FirstName}
                    onChange={(e) => {
                      handleChange("FirstName", e.target.value)
                    }}
                  />
                  <p className="text-danger">{validated && !cliendDet?.FirstName?.length && "Please Enter First Name"}</p>
                </div>
                <div className="col-lg-3 mt-4">
                  <label htmlFor="" className="text-grey">
                    Middle Name
                  </label>
                  <input type="text" className="form-control tasKCategory1"
                    value={cliendDet.MiddleName}
                    onChange={(e) => {
                      handleChange("MiddleName", e.target.value)
                    }} />
                  {/* <p className="text-danger">{validated && !cliendDet?.MiddleName?.length && "Please Enter Middle Name"}</p> */}
                </div>
                <div className="col-lg-3 mt-4">
                  <label htmlFor="" className="label- text-grey">
                    Last Name
                  </label>
                  <input type="text" className="form-control tasKCategory1"
                    value={cliendDet.LastName}
                    onChange={(e) => { handleChange("LastName", e.target.value) }} />

                  <p className="text-danger">{validated && !cliendDet?.LastName?.length && "Please Enter Last Name"}</p>
                </div>
                <div className="col-lg-3 position-relative mt-4">
                  <div className="d-flex justify-content-between align-center">
                    <label htmlFor="" className="label- text-grey"

                    >
                      Mobile
                    </label>
                    {/* <div>
                          <button className="send-otp-btn"
                          >Send OTP</button>
                        </div> */}
                  </div>
                  <input type="number" className="form-control tasKCategory1"
                    value={cliendDet.Phone}
                    onChange={(e) => {
                      handleChange("Phone", e.target.value)
                    }}
                  />
                  <p className="text-danger">{validated && cliendDet.Phone.length != 10 && "Please Enter Mobile No"}</p>
                  {/* <img
                  src={righticon}
                  alt=""
                  className="right-icon-img-modal"
                /> */}
                </div>
                {/* {
                      isFiiledDetails &&

                      <div className="col-lg-3 position-relative mt-4">
                        <label htmlFor="" className="label-text">
                          Mobile OTP Verification
                        </label>
                        <input type="text" className="form-control tasKCategory1"
                          value={cliendDet.noOtp}
                          onChange={(e) => handleChange('noOtp', e.target.value)}
                        />
                        <p className="text-danger">{validated && !cliendDet?.noOtp?.length && "Please Enter OTP"}</p>
                        <img
                          src={righticon}
                          alt=""
                          className="right-icon-img-modal"
                        />
                      </div>
                    } */}
                <div className="col-lg-3 position-relative mt-4">
                  <div className="d-flex justify-content-between align-center">
                    <label htmlFor="" className="text-grey">
                      Email
                    </label>
                    {/* <div>
                          <button className="send-otp-btn"

                          >Send OTP</button>
                        </div> */}
                  </div>
                  <input type="text" className="form-control tasKCategory1"
                    value={cliendDet.Email}
                    onChange={(e) => {
                      handleChange("Email", e.target.value)
                    }}
                  />
                  <p className="text-danger">{validated && !validEmail(cliendDet?.Email) && "Please Enter Email"}</p>
                  {
                    cliendDet?.Email && !validated && (
                      <img
                        src={righticon}
                        alt=""
                        className="right-icon-img-modal"
                      />
                    )
                  }
                </div>
                {/* {
                      isFiiledDetails &&

                      <div className="col-lg-3 position-relative mt-4">
                        <label htmlFor="" className="label-text">
                          Email OTP Verification
                        </label>
                        <input type="text" className="form-control tasKCategory1"
                          value={cliendDet.emailOtp}
                          onChange={(e) => handleChange('emailOtp', e.target.value)} />
                        <p className="text-danger">{validated && !cliendDet?.emailOtp?.length && "Please Enter Email"}</p>
                        <img
                          src={righticon}
                          alt=""
                          className="right-icon-img-modal"
                        />
                      </div>
                    } */}
              </div>
            </Modal.Body>
            <div className="hr-line-modal-1">
              <hr style={{ margin: "0" }} />
            </div>
            <Modal.Footer>
              {/* <div className="d-flex justify-content-end align-items-center mainBtnsSub">
            <button
              type="button"
              className="btn-width cancelBtn mx-3"
              onClick={handleClose}
            >
              Cancel
            </button>
            <button
              className="btn-width saveBtn"
              disabled={btnLoading ? true : false}
            >
              {btnLoading ? (
                <div className="d-flex justify-content-center align-items-center">
                  <ClipLoader color="#fff" size={18} className="me-2" />
                </div>
              ) : (
                "Add"
              )}
            </button>
          </div> */}
              <div className="model-btn22 mainBtnsSub">
                <button
                  type="button"
                  className="btn-width cancelBtn mx-3"
                  onClick={handleClose}
                >
                  Cancel
                </button>
                {/* <CommonButton
  className="me-2 add-btnmembr"
  title={cliendDet?.Id === 0 ? "Add" : "Update"}
  isLoading={isApiLoad}
  handlerFunction={handleCreate}
/> */}
                <button
                  className="btn-width saveBtn me-2"
                  disabled={isApiLoad}
                  onClick={handleCreate}
                >
                  {isApiLoad ? (
                    <div className="d-flex justify-content-center align-items-center">
                      <ClipLoader color="#fff" size={18} className="me-2" />
                      <span>{cliendDet?.Id === 0 ? "Adding..." : "Updating..."}</span>
                    </div>
                  ) : (
                    cliendDet?.Id === 0 ? "Add" : "Update"
                  )}
                </button>

              </div>
            </Modal.Footer>
          </Modal>


        </div>
        <div className="row mt-4">
          <div className="col-lg-12">
            <Pagination
              totalPage={totalPage}
              currentPage={currentPage}
              pageChangeHandler={(page) => setCuurentPage(page + 1)}
            />
          </div>
        </div>


        <Modal
          className="delete-news-modal"
          show={show1} onHide={handleCloses}
          dialogClassName="modal-90w"
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title>{clientId.current?.isActive === true ? "De-Active Client  " : "Active Client"}</Modal.Title>
          </Modal.Header>
          <div class="lineSeperate"></div>
          <Modal.Body className="delete-body ps-4">
            <p>
              Are You Sure You Want To {clientId.current?.isActive ? "DeActive" : "Active"}{" "}
              <b>{clientId.current?.firstName} {clientId.current?.lastName}</b>
              {/* {"( "+deleteProjectName + " )"} */}
            </p>
          </Modal.Body>

          <div className="lineSeperate"></div>
          <div className="d-flex justify-content-end align-items-center mainBtnsSub">
            <button className="btn-width cancelBtn mx-3" onClick={handleCloses}>
              Cancel
            </button>
            <button
              className="btn-width saveBtn"
              onClick={() => {
                onActiveSubscription()
              }}
            >
              {clientId.current?.isActive === true ? "De Active" : "Active"}
            </button>
          </div>
        </Modal>

      </>


    </div>
  );
}

export default Members;
